import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Modal, Button, FormGroup, FormControl, ControlLabel, HelpBlock, Tab, Tabs } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import {
  difference, map, indexOf, each, isArray, isObject, isString,
  concat, without,
} from 'lodash';
import moment from 'moment';
import Fa from 'react-fontawesome';

import NumberFormat from 'react-number-format';
import { getAllProducts } from '../../../Setup/SetupReducer';
import { winLossEditOpportunity, winLossUpdateOpportunity,
  winLossEditOpportunitySelectContacts,
  winLossEditOpportunityEditContact, validateOpportunity } from '../../WinLossActions';
import { getWinLossEditingOpportunity } from '../../WinLossReducer';
import ContactList from '../contact-list';
import WindowResizeListener from '../../../../components/window-size-listener';

import ProductTable from './tv-produtc-table';
import { getUser, getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class EditModal extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
      contactContainerWidth: 0,
    };
    this.close = this.close.bind(this);
    this.renderErrors = this.renderErrors.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
    this.renderField = this.renderField.bind(this);
    this.renderNumericField = this.renderNumericField.bind(this);
    this.handleSelectContacts = this.handleSelectContacts.bind(this);
    this.handleEditContact = this.handleEditContact.bind(this);
    this.handleWebsiteField = this.handleWebsiteField.bind(this);
    this.onSelectProducts = this.onSelectProducts.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    const { isOpen } = this.props;
    if (!isOpen && nextProps.isOpen) {
      const { opportunity } = nextProps;
      const values = { ...opportunity };
      if (values.account && values.account.website) {
        let website = values.account.website.toLowerCase();
        if (website.indexOf('http://') < 0 && website.indexOf('https://') < 0) {
          website = `http://${website}`;
        }
        values.account.website = website;
      }
      this.props.initialize({
        name: values.name,
        amount: values.amount,
        additional_information: values.additional_information || '',
        question: values.question || '',
        selected_product_id: values.selected_product_id,
        selected_product_ids: values.selected_product_ids,
        account: {
          name: values.account.name,
          website: values.account.website,
          annual_revenue: values.account.annual_revenue,
          number_of_employees: values.account.number_of_employees,
          industry: values.account.industry,
          phone: values.account.phone,
        },
      });
      this.setState({ tab: nextProps.tab });
    }
  }

  onWindowResize() {
    if (this.contactContainer) {
      this.setState({ contactContainerWidth: this.contactContainer.offsetWidth });
    }
  }
  close() {
    const { opportunity } = this.props;
    if (opportunity) {
      this.props.dispatch(winLossEditOpportunity(opportunity));
    }
  }
  handleSubmit(data) {
    const { valid } = this.props;
    const { opportunity } = this.props;
    if (valid) {
      const account = { ...opportunity.account, ...data.account };
      const params = { ...opportunity, ...data, account };
      this.props.dispatch(winLossUpdateOpportunity(opportunity.opportunity_id, params))
        .then(
          (newParams) => {
            this.props.onUpdateOpportunity(newParams);
            this.close();
          }
        );
    }
  }

  handleTabSelect(tab) {
    this.setState({ tab });
  }

  onSelectProducts(products) {
    this.props.change('selected_product_ids', map(products, 'id'));
  }

  contactTabOnSelect() {
    this.onWindowResize();
  }

  handleSelectContacts(contacts) {
    this.props.dispatch(winLossEditOpportunitySelectContacts(contacts));
  }
  handleEditContact(contact) {
    this.props.dispatch(winLossEditOpportunityEditContact(contact));
  }

  handleWebsiteField(newValue) {
    const validValues = ['h', 'ht', 'htt', 'http', 'http:', 'http:/', 'http://', 'https', 'https:', 'https:/', 'https://'];
    if (newValue &&
      newValue.indexOf('http://') < 0 &&
      newValue.indexOf('https://') < 0
    ) {
      const found = indexOf(validValues, newValue) >= 0;
      if (!found) {
        return `http://${newValue}`;
      }
    }
    return newValue;
  }

  renderErrors(errors, selectedContacts) {
    const errorNodes = [];
    if (selectedContacts && selectedContacts.length) {
      delete errors.selectedContacts;
    }
    each(errors, (v, k) => {
      let node = null;
      if (isString(v)) {
        node = (<span>{v}</span>);
      } else if (isArray(v)) {
        node = v.map((val, i) => (<span key={i}>{val}</span>));
      } else if (isObject(v)) {
        node = (<div>
          <div>{k}:</div>
          {this.renderErrors(v)}
        </div>);
      }
      errorNodes.push(<li key={k}>{node}</li>);
    });
    return (<ul>{errorNodes}</ul>);
  }

  renderField({
    input, label, type, placeholder, className, componentClass, hint, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          {...input}
          componentClass={componentClass}
          placeholder={placeholder}
          type={type}
          disabled={submitting}
        />
        <FormControl.Feedback />
        {hint !== undefined && <HelpBlock>{hint}</HelpBlock>}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderNumericField({
    input, label, type, prefix, placeholder, className, thousandSeparator, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState} className={className}>
        <ControlLabel>{label}</ControlLabel>
        <NumberFormat
          value={input.value}
          thousandSeparator={thousandSeparator}
          className="form-control"
          prefix={prefix}
          placeholder={placeholder}
          onValueChange={(values, e) => {
            this.props.change(input.name, parseFloat(values.value));
            this.props.touch(input.name);
          }}
        />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }
  renderOpportunityTab() {
    const { opportunity, organization } = this.props;
    const { owner } = opportunity;
    const closeDate = opportunity.close_date;
    const closeDateStr = closeDate ? moment(closeDate).format('MMM DD, YYYY') : null;
    const outcome = opportunity.stage;
    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix;
      symbol = organization.currency_symbol;
    }
    let sizeLabel = 'Opportunity Size';
    if (suffix && suffix.length) {
      sizeLabel += ` (${suffix})`;
    }
    return (
      <div>
        <Field name="name" type="text" component={this.renderField} label="Opportunity Name" />
        <Field
          name="amount"
          type="text"
          component={this.renderNumericField}
          label={sizeLabel}
          thousandSeparator
          prefix={symbol}
        />
        <div className="row">
          <div className="col-sm-6">
            <FormGroup>
              <ControlLabel>Close Date</ControlLabel>
              <FormControl type="text" disabled readOnly value={closeDateStr || 'N/A'} />
            </FormGroup>
          </div>
          <div className="col-sm-6">
            <FormGroup>
              <ControlLabel>Outcome</ControlLabel>
              <FormControl type="text" disabled readOnly value={outcome || 'N/A'} />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <FormGroup>
              <ControlLabel>Opportunity Owner</ControlLabel>
              <FormControl type="text" disabled readOnly value={owner ? owner.name : 'N/A'} />
            </FormGroup>
          </div>
        </div>
      </div>
    );
  }

  renderAccountTab() {
    const { opportunity } = this.props;
    const { account } = opportunity;
    return (
      <div>
        <Field
          name="account.name"
          type="text"
          component={this.renderField}
          label="Account Name"
          placeholder="account name"
        />
        <div className="row">
          <Field
            name="account.annual_revenue"
            type="text"
            component={this.renderNumericField}
            label="Annual Revenue"
            thousandSeparator
            className="col-sm-6"
            prefix="$"
            placeholder="account annual revenue"
          />
          <Field
            name="account.number_of_employees"
            type="text"
            component={this.renderNumericField}
            label="Number of Employees"
            className="col-sm-6"
            thousandSeparator
            placeholder="number of account's employees"
          />
        </div>
        <div className="row">
          <Field
            name="account.industry"
            className="col-sm-6"
            type="text"
            component={this.renderField}
            label="Industry"
            placeholder="account's field of industry"
          />
          <Field
            name="account.phone"
            className="col-sm-6"
            type="text"
            component={this.renderField}
            label="Phone"
            placeholder="account's phone number"
          />
        </div>
        <Field
          name="account.website"
          type="text"
          component={this.renderField}
          label="Website"
          placeholder="account's website"
          normalize={this.handleWebsiteField}
        />

      </div>
    );
  }

  renderAdditionalInfoTab() {
    return (
      <div>
        <Field
          name="question"
          componentClass="textarea"
          component={this.renderField}
          label="Opportunity Questions"
          placeholder="Add additional questions you would like TruVoice by Corporate Visions to ask the buyers for this opportunity."
        />
        <Field
          name="additional_information"
          componentClass="textarea"
          component={this.renderField}
          label="Additional Opportunity Information"
          placeholder="Add additional information you would like TruVoice by Corporate Visions to know about this opportunity or the contact we will be speaking to."
        />
      </div>
    );
  }

  render() {
    const {
      opportunity, isOpen, handleSubmit, submitFailed, 
      submitting, formValues, selectedProductIds,
    } = this.props;
    const hasOpportunity = opportunity !== null && opportunity !== undefined;
    const tracking = hasOpportunity ? opportunity.tracking : null;
    const selectedContactIds = hasOpportunity ? map(opportunity.selected_contacts, 'contact_id') : [];
    const submittedContactIds = tracking ? tracking.submittedContactIds : [];

    let contactTab = 'Contacts';
    if (selectedContactIds.length === 0) {
      contactTab = (
        <span>
          Contacts <Fa name="exclamation-triangle" className="text-danger" />
        </span>
      );
    } else {
      contactTab = (
        <span>
          Contacts <span className="badge">{selectedContactIds.length}</span>
        </span>
      );
    }

    let productTab = 'Products';
    if (selectedProductIds.length === 0) {
      productTab = (
        <span>
          Products <Fa name="exclamation-triangle" className="text-danger" />
        </span>
      );
    } else {
      productTab = (
        <span>
          Products <span className="badge">{selectedProductIds.length}</span>
        </span>
      );
    }


    return (
      <Modal show={isOpen} backdrop="static" keyboard={false} onHide={this.close} bsSize="lg">
        {hasOpportunity && <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Opportunity, Account &amp; Contact Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="well well-sm">
              Update opportunity information prior to submitting this opportunity to TruVoice.
              Make sure at least one contact has been selected in the <strong>Contacts</strong> tab 
              and at least one product has been selected in the <strong>Product</strong> tab.
            </div>
            {submitFailed && <div className="alert alert-danger">
              {this.renderErrors(validateOpportunity(formValues), selectedContactIds)}
            </div>}
            <div ref={(el) => { this.contactContainer = el; }}>
              <p />
              <WindowResizeListener onResize={this.onWindowResize} />
            </div>
            <Tabs activeKey={this.state.tab} onSelect={this.handleTabSelect} id="opportunity-edit-tabs">
              <Tab eventKey={1} title="Opportunity">
                <p />
                {this.renderOpportunityTab()}
              </Tab>
              <Tab eventKey={2} title="Account">
                <p />
                {this.renderAccountTab()}
              </Tab>
              <Tab
                eventKey={3}
                title={contactTab}
                onSelect={this.contactTabOnSelect}
              >
                <p />
                <ContactList
                  account={opportunity.account}
                  selectedContacts={opportunity.selected_contacts}
                  opportunityContacts={opportunity.contacts}
                  width={this.state.contactContainerWidth}
                  submittedContactIds={submittedContactIds || []}
                  onSelectContacts={this.handleSelectContacts}
                  onEditContact={this.handleEditContact}
                  isActive={(isOpen && this.state.tab === 3)}
                  disabledWhenSubmitted
                  editingContact={opportunity.editingContact}
                />
              </Tab>
              <Tab
                eventKey={4}
                title={productTab}
                onSelect={this.contactTabOnSelect}
              >
                <p />
                <ProductTable
                  disabled={submitting}
                  products={this.props.products}
                  width={this.state.contactContainerWidth}
                  selectedProductIds={this.props.selectedProductIds}
                  onSelectProducts={this.onSelectProducts}
                  isActive={(isOpen && this.state.tab === 4)}
                />
              </Tab>
              <Tab eventKey={5} title="Other">
                <p />
                {this.renderAdditionalInfoTab()}
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer>
            <div className="row">
              <div className="col-sm-6 col-sm-push-6">
                <div className="pull-right">
                  <Button bsStyle="link" onClick={this.close}>Cancel</Button>
                  <Button bsStyle="primary" type="submit">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>}
      </Modal>
    );
  }
}

EditModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  opportunity: PropTypes.shape({}),
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  change: PropTypes.func,
  initialize: PropTypes.func,
  tab: PropTypes.number,
  touch: PropTypes.func,
  valid: PropTypes.bool,
  loginUser: PropTypes.shape({}).isRequired,
  selectedProductId: PropTypes.string,
  selectedProductIds: PropTypes.arrayOf(PropTypes.string),
  allProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tvProductMappings: PropTypes.shape({}),
  organization: PropTypes.shape({}),
  onUpdateOpportunity: PropTypes.func,
};
EditModal.defaultProps = {
  tab: 1,
  opportunity: null,
  submitting: false,
  submitFailed: false,
  handleSubmit: () => {},
  reset: () => {},
  change: () => {},
  initialize: () => {},
  selectedProductId: null,
  selectedProductIds: [],
  touch: () => {},
  tvProductMappings: {},
  valid: false,
  organization: null,
  onUpdateOpportunity: () => {},
};

const selector = formValueSelector('winLossEditingOpportunityForm'); // <-- same as form name

function mapStateToProps(state) {
  const editingOpportunity = getWinLossEditingOpportunity(state);
  return {
    opportunity: editingOpportunity,
    organization: getUserCurrentOrganization(state),
    loginUser: getUser(state),
    allProducts: getAllProducts(state),
    selectedProductId: selector(state, 'selected_product_id'),
    selectedProductIds: selector(state, 'selected_product_ids'),
    formValues: selector(
      state, 'name', 'amount', 'selected_product_id', 'selected_product_ids',
      'account.name', 'account.industry', 'account.annual_revenue',
      'account.number_of_employees', 'account.website',
    ),
    isOpen: editingOpportunity !== undefined && editingOpportunity !== null,
  };
}

const validate = values => validateOpportunity(values);

const EditModalForm = reduxForm({
  form: 'winLossEditingOpportunityForm',
  validate,
})(EditModal);

export default connect(mapStateToProps)(EditModalForm);
